
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { ContractFormValues } from "../ContractFormSchema";
import { PaymentTypeSection } from "./PaymentTypeSection";
import { FeatureGuard } from "@/components/common/FeatureGuard";

interface PaymentScheduleSectionProps {
  form: UseFormReturn<ContractFormValues>;
}

export function PaymentScheduleSection({ form }: PaymentScheduleSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <FormField
          control={form.control}
          name="paymentFrequencyInterval"
          render={({ field }) => (
            <FormItem className="col-span-1">
              <FormLabel>{t("Payment Frequency")}</FormLabel>
              <FormControl>
                <Input 
                  type="number" 
                  placeholder={t("Frequency (e.g. 1, 3, 6)")}
                  {...field}
                  onChange={(e) => field.onChange(e.target.valueAsNumber || 1)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="paymentFrequencyUnit"
          render={({ field }) => (
            <FormItem className="col-span-1">
              <FormLabel>{t("Unit")}</FormLabel>
              <Select
                onValueChange={field.onChange}
                value={field.value}
              >
                <FormControl>
                  <SelectTrigger>
                    <SelectValue placeholder={t("Select unit")} />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  <SelectItem value="Day">{t("Day")}</SelectItem>
                  <SelectItem value="Month">{t("Month")}</SelectItem>
                  <SelectItem value="Year">{t("Year")}</SelectItem>
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>

      <FeatureGuard feature="payment_type_selection" showPreview={true}>
        <PaymentTypeSection form={form} />
      </FeatureGuard>
    </>
  );
}
